<template>
  <iColumn align="center">
    <iRow
      align="center"
      vertical-align="middle"
      wrap="nowrap"
      :style-overrides="{
        borderWidth: 'thin',
        borderRadius: 'small',
        borderColor: 'standard',
        paddingTop: 'small',
        paddingBottom: 'small',
        paddingLeft: 'small',
        paddingRight: 'small',
      }"
    >
      <iText variant="subtle" text-align="center">
        This publication is private and does not allow sign ups
      </iText>
    </iRow>
    <iLink @click="gotToChangeEmail">
      or use a different email
    </iLink>
  </iColumn>
</template>

<script>
import { mapWritableState } from "pinia";
import { useLoginSignupStore } from "%/dynamic-component-editor/stores/login-signup-store";

export default {
  name: "JoinPublicationPrivatePublication",
  computed: {
    ...mapWritableState(useLoginSignupStore, [
      "userFlowSteps",
    ]),
  },
  methods: {
    gotToChangeEmail() {
      this.userFlowSteps.pop();
    },
  },
};
</script>
